// Dependencies
import React, { FunctionComponent } from 'react'

// Types
import { FaqProps } from './faq.types'

// Styles
import {
  Container,
  ContentWrapper,
  FaqContentWrapper,
  FaqSectionTitle,
  Separator
} from './faq.styles'

export const Faq: FunctionComponent<FaqProps> = ({
  title,
  accordionComposition,
  needHelpComposition
}) => {
  return (
    <Container>
      <ContentWrapper>
        <FaqContentWrapper>
          <FaqSectionTitle>{title}</FaqSectionTitle>

          {accordionComposition}
        </FaqContentWrapper>

        <Separator />

        {needHelpComposition}
      </ContentWrapper>
    </Container>
  )
}
